'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _SpriteState2 = require('./SpriteState');

var _SpriteState3 = _interopRequireDefault(_SpriteState2);

var _constants = require('../constants/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayState = function (_SpriteState) {
  _inherits(PlayState, _SpriteState);

  function PlayState() {
    _classCallCheck(this, PlayState);

    return _possibleConstructorReturn(this, (PlayState.__proto__ || Object.getPrototypeOf(PlayState)).apply(this, arguments));
  }

  _createClass(PlayState, [{
    key: 'init',
    value: function init(data) {
      this.keys = this.game.input.keyboard.addKeys({
        left: _phaser2.default.KeyCode.LEFT,
        right: _phaser2.default.KeyCode.RIGHT,
        up: _phaser2.default.KeyCode.UP
      });
      this.ringCount = 0;
      this.score = 0;
      this.level = (data.level || 0) % _constants.LEVEL_COUNT;
      this.timeCount = 0;
      this.bgm = this.game.add.audio('bgm');
      this.bgm.loopFull();
    }
  }, {
    key: 'create',
    value: function create() {
      // fade in (from black)
      this.camera.flash('#000000');
      // create sound entities
      this.sfx = {
        jump: this.game.add.audio('sfx:jump'),
        spring: this.game.add.audio('sfx:spring'),
        ring: this.game.add.audio('sfx:ring'),
        pop: this.game.add.audio('sfx:pop'),
        finish: this.game.add.audio('sfx:finish'),
        hurt: this.game.add.audio('sfx:hurt'),
        dead: this.game.add.audio('sfx:dead')

        // create level entities and decoration
      };this.game.add.image(0, 0, 'background');
      this.loadLevel(this.game.cache.getJSON('level:' + this.level));
      // Start time
      this.game.time.events.loop(_phaser2.default.Timer.SECOND, this.updateTime, this);
      // create UI score boards
      this.createHud();
    }
  }, {
    key: 'updateTime',
    value: function updateTime() {
      this.timeCount++;
    }
  }, {
    key: 'formatTime',
    value: function formatTime() {
      var mins = Math.floor(this.timeCount / 60);
      var secs = this.timeCount % 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      var formatted = mins + ':' + secs;
      return formatted;
    }
  }, {
    key: 'update',
    value: function update() {
      this.handleCollisions();
      this.handleInput();
      // update scoreboards
      this.scoreNumber.text = '' + this.score;
      this.ringNumber.text = '' + this.ringCount;
      this.timeNumber.text = '' + this.formatTime();
    }
  }, {
    key: 'shutdown',
    value: function shutdown() {
      this.bgm.stop();
    }
  }, {
    key: 'handleCollisions',
    value: function handleCollisions() {
      this.game.physics.arcade.collide(this.enemies, this.platforms);
      this.game.physics.arcade.collide(this.enemies, this.enemyWalls);
      this.game.physics.arcade.collide(this.hero, this.platforms);
      this.game.physics.arcade.collide(this.hero, this.movingBlocks);
      this.game.physics.arcade.collide(this.movingBlocks, this.platforms);
      this.game.physics.arcade.collide(this.movingBlocks, this.movingBlocks);

      // collision: hero vs enemies (kill or die)
      this.game.physics.arcade.overlap(this.hero, this.enemies, this.onHeroVsEnemy, null, this);
      // collision: lava
      this.game.physics.arcade.collide(this.hero, this.lava, this.handleDamage, null, this);
      // collision: spring
      this.game.physics.arcade.overlap(this.hero, this.spring, this.onHeroVsSpring, null, this);
      // collision: fireball
      this.game.physics.arcade.overlap(this.hero, this.fireball, this.handleDamage, null, this);
      // collision: spikes
      this.game.physics.arcade.overlap(this.hero, this.spike, this.handleDamage, null, this);
      // collision: rings
      this.game.physics.arcade.overlap(this.hero, this.rings, this.onHeroVsRing, null, this);
      // collision: finish
      this.game.physics.arcade.overlap(this.hero, this.finish, this.onHeroVsFinish,
      // ignore if there is no key or the player is on air
      function (hero, finish) {
        return hero.body.touching.down;
      }, this);
    }
  }, {
    key: 'handleInput',
    value: function handleInput() {
      if (this.keys.left.isDown) {
        // move hero left
        this.hero.move(-1);
      } else if (this.keys.right.isDown) {
        // move hero right
        this.hero.move(1);
      } else {
        // stop
        this.hero.move(0);
      }
      // handle jump
      if (this.keys.up.downDuration(200)) {
        var didJump = this.hero.jump();
        didJump ? this.sfx.jump.play() : this.hero.stopJumpBoost();
      }
    }
  }, {
    key: 'onHeroVsRing',
    value: function onHeroVsRing(hero, ring) {
      this.sfx.ring.play();
      ring.kill();
      this.ringCount++;
    }
  }, {
    key: 'handleDamage',
    value: function handleDamage(hero) {
      var _this2 = this;

      if (this.ringCount === 0 && !hero.invincible) {
        hero.die();
        this.sfx.dead.play();
        hero.events.onKilled.addOnce(function () {
          _this2.game.state.restart(true, false, {
            level: _this2.level
          });
        });
      } else if (hero.invincible) {} else {
        this.ringCount = 0;
        hero.injure();
        this.sfx.hurt.play();
      }
    }
  }, {
    key: 'onHeroVsEnemy',
    value: function onHeroVsEnemy(hero, enemy) {
      // the hero can kill enemies when is falling (after a jump, or a fall)
      if (hero.body.velocity.y !== 0) {
        enemy.die();
        hero.bounce();
        this.sfx.pop.play();
        this.score += 100;
      } else {
        this.handleDamage(hero);
        // NOTE: bug in phaser in which it modifies 'touching' when
        // checking for overlaps. This undoes that change so enemies don't
        // 'bounce' agains the hero
        enemy.body.touching = enemy.body.wasTouching;
      }
    }
  }, {
    key: 'onHeroVsSpring',
    value: function onHeroVsSpring(hero, spring) {
      if (hero.body.velocity.y > 0) {
        spring.animations.play('jump');
        var didJump = this.hero.jump(900);
        if (didJump) {
          this.sfx.spring.play();
        }
      }
    }
  }, {
    key: 'onHeroVsFinish',
    value: function onHeroVsFinish(hero, finish) {
      this.sfx.finish.play();
      finish.animations.play('open');
      // play animation and change to the next level when it ends
      hero.freeze();
      this.game.add.tween(hero).to({
        x: 940,
        alpha: 0
      }, 500, null, true).onComplete.addOnce(this.goToNextLevel, this);
    }
  }, {
    key: 'goToNextLevel',
    value: function goToNextLevel() {
      this.camera.fade('#000000');
      this.camera.onFadeComplete.addOnce(function () {
        // change to next level
        this.game.state.restart(true, false, {
          level: this.level + 1,
          score: this.score + 1000
        });
      }, this);
    }
  }, {
    key: 'loadLevel',
    value: function loadLevel(data) {
      // create all the groups/layers that we need
      this.bgDecoration = this.game.add.group();
      this.rings = this.game.add.group();
      this.enemies = this.game.add.group();
      this.enemyWalls = this.game.add.group();
      this.enemyWalls.visible = false;
      this.movingBlocks = this.game.add.group();
      this.fireball = this.game.add.group();
      this.lava = this.game.add.group();
      this.spring = this.game.add.group();
      this.spike = this.game.add.group();
      this.platforms = this.game.add.group();
      this.finish = this.game.add.group();
      // spawn
      this.spawnCharacters({
        hero: data.hero,
        enemies: data.enemies
      });
      data.platforms.forEach(this.spawnPlatform, this);
      data.movingBlocks.forEach(this.spawnMovingBlocks, this);
      data.lava.forEach(this.spawnLava, this);
      data.spring.forEach(this.spawnSpring, this);
      data.rings.forEach(this.spawnRings, this);
      this.spawnSpike({
        spike: data.spike
      });
      this.spawnFireball({
        fireball: data.fireball
      });
      this.spawnFinish({
        finish: data.finish
      });
      data.decoration.forEach(function (deco) {
        this.bgDecoration.add(this.game.add.image(deco.x, deco.y, 'decoration', deco.frame));
      }, this);

      // enable gravity
      this.game.physics.arcade.gravity.y = 1200;
    }
  }, {
    key: 'createHud',
    value: function createHud() {
      var NUMBERS_STR = '0123456789:';
      var LETTERS_STR = 'SCORINGTME';
      this.scoreText = this.game.add.retroFont('font:letters', 14, 17, LETTERS_STR, 10);
      this.timeText = this.game.add.retroFont('font:letters', 14, 17, LETTERS_STR, 10);
      this.ringText = this.game.add.retroFont('font:letters', 14, 17, LETTERS_STR, 10);
      this.scoreNumber = this.game.add.retroFont('font:numbers', 14, 17, NUMBERS_STR, 11);
      this.timeNumber = this.game.add.retroFont('font:numbers', 14, 17, NUMBERS_STR, 11);
      this.ringNumber = this.game.add.retroFont('font:numbers', 14, 17, NUMBERS_STR, 11);

      this.scoreText.text = 'SCORE';
      this.timeText.text = 'TIME';
      this.ringText.text = 'RINGS';

      var scoreTextImage = this.game.make.image(50, 25, this.scoreText);
      var timeTextImage = this.game.make.image(50, 25, this.timeText);
      var ringsTextImage = this.game.make.image(50, 25, this.ringText);
      var scoreNumberImage = this.game.make.image(50, 25, this.scoreNumber);
      var timeNumberImage = this.game.make.image(50, 25, this.timeNumber);
      var ringsNumberImage = this.game.make.image(50, 25, this.ringNumber);

      this.hud = this.game.add.group();
      this.hud.add(scoreTextImage);
      this.hud.add(timeTextImage);
      this.hud.add(ringsTextImage);
      this.hud.add(scoreNumberImage);
      this.hud.add(timeNumberImage);
      this.hud.add(ringsNumberImage);

      this.hud.position.set(10, 10);
      this.hud.children[0].position.set(20, 20);
      this.hud.children[1].position.set(20, 50);
      this.hud.children[2].position.set(20, 80);
      this.hud.children[3].position.set(140, 20);
      this.hud.children[4].position.set(100, 50);
      this.hud.children[5].position.set(140, 80);
      console.log(this.hud.children[3]);
    }
  }]);

  return PlayState;
}(_SpriteState3.default);

exports.default = PlayState;


//////////////////
// WEBPACK FOOTER
// ./src/states/PlayState.js
// module id = 337
// module chunks = 0